import React from 'react'
import { Header, Hero, CreateJob } from '../components'
import { useEffect } from 'react'
import { loadData } from '../services/blockchain'



const Home = () => {
  useEffect(() => {
    loadData()
    const interval = setInterval(() => {
      loadData()
    }, 20000) // Poll every 20 seconds

    return () => clearInterval(interval)
  }, [])
  return (
    <div>
      <Header />
      <Hero />
      <CreateJob />
    </div>
  )
}

export default Home
